import { SidebarItemType } from 'types/sidebar';

const dashboardItemList: SidebarItemType[] = [
  {
    href: '/home',
    title: 'Home',
    name: 'Home',
  },
  {
    href: '/gateway',
    title: '게이트웨이 관리',
    name: '게이트웨이 관리',
  },
  {
    href: '/client',
    title: '클라이언트 관리',
    name: '클라이언트 관리',
  },
  // {
  //   href: '/communication',
  //   title: '통신현황',
  //   name: '통신현황',
  // },
  {
    href: '/user',
    title: '사용자 관리',
    name: '사용자 관리',
  },
  {
    href: '/customer',
    title: '고객사 관리',
    name: '고객사 관리',
  },
  {
    href: '/admin',
    title: '관리자 관리',
    name: '관리자 관리',
  },
  {
    href: '/board/notice',
    title: '공지사항',
    name: '공지사항',
  },
  {
    href: '/board/inquiry',
    title: '고객 문의',
    name: '고객 문의',
  },
];
export default dashboardItemList;

